import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=c2c4e680&scoped=true&"
import script from "./uploadImage.vue?vue&type=script&lang=js&"
export * from "./uploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4e680",
  null
  
)

export default component.exports